export default function padTo2Digits(n: number) {
	return n.toString().padStart(2, '0')
}
